"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMultipartUpload = void 0;
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
const utils_1 = require("@aws-amplify/core/internals/utils");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const utils_2 = require("../utils");
const validateObjectUrl_1 = require("../../validateObjectUrl");
const base_1 = require("./base");
const createMultipartUploadSerializer = async (input, endpoint) => {
    const headers = {
        ...(await (0, utils_2.serializeObjectConfigsToHeaders)(input)),
        ...(0, utils_2.assignStringVariables)({
            'x-amz-checksum-algorithm': input.ChecksumAlgorithm,
            'x-amz-checksum-type': input.ChecksumType,
            'x-amz-expected-bucket-owner': input.ExpectedBucketOwner,
        }),
    };
    const url = new utils_1.AmplifyUrl(endpoint.url.toString());
    (0, utils_2.validateS3RequiredParameter)(!!input.Key, 'Key');
    url.pathname = (0, utils_2.serializePathnameObjectKey)(url, input.Key);
    url.search = 'uploads';
    (0, validateObjectUrl_1.validateObjectUrl)({
        bucketName: input.Bucket,
        key: input.Key,
        objectURL: url,
    });
    return {
        method: 'POST',
        headers,
        url,
    };
};
const createMultipartUploadDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        // error is always set when statusCode >= 300
        throw (0, utils_2.buildStorageServiceError)((await (0, base_1.parseXmlError)(response)));
    }
    else {
        const parsed = await (0, utils_2.parseXmlBody)(response);
        const contents = (0, utils_2.map)(parsed, {
            UploadId: 'UploadId',
        });
        return {
            $metadata: (0, aws_client_utils_1.parseMetadata)(response),
            ...contents,
        };
    }
};
exports.createMultipartUpload = (0, composers_1.composeServiceApi)(utils_2.s3TransferHandler, createMultipartUploadSerializer, createMultipartUploadDeserializer, { ...base_1.defaultConfig, responseType: 'text' });
